export interface Bookmaker {
  key: string;
  title: string;
  region: string;
}

export const BOOKMAKERS: Bookmaker[] = [
  // US Bookmakers
  { key: 'betonlineag', title: 'BetOnline.ag', region: 'us' },
  { key: 'betmgm', title: 'BetMGM', region: 'us' },
  { key: 'betrivers', title: 'BetRivers', region: 'us' },
  { key: 'betus', title: 'BetUS', region: 'us' },
  { key: 'bovada', title: 'Bovada', region: 'us' },
  { key: 'williamhill_us', title: 'Caesars', region: 'us' },
  { key: 'draftkings', title: 'DraftKings', region: 'us' },
  { key: 'fanatics', title: 'Fanatics', region: 'us' },
  { key: 'fanduel', title: 'FanDuel', region: 'us' },
  { key: 'lowvig', title: 'LowVig.ag', region: 'us' },
  { key: 'mybookieag', title: 'MyBookie.ag', region: 'us' },

  // US2 Bookmakers
  { key: 'ballybet', title: 'Bally Bet', region: 'us2' },
  { key: 'betanysports', title: 'BetAnything', region: 'us2' },
  { key: 'betparx', title: 'betPARX', region: 'us2' },
  { key: 'espnbet', title: 'ESPN BET', region: 'us2' },
  { key: 'fliff', title: 'Fliff', region: 'us2' },
  { key: 'hardrockbet', title: 'Hard Rock Bet', region: 'us2' },
  { key: 'rebet', title: 'ReBet', region: 'us2' },

  // US Exchanges
  { key: 'betopenly', title: 'BetOpenly', region: 'us_ex' },
  { key: 'novig', title: 'Novig', region: 'us_ex' },
  { key: 'prophetx', title: 'ProphetX', region: 'us_ex' },

  // UK Bookmakers
  { key: 'sport888', title: '888sport', region: 'uk' },
  { key: 'betfair_ex_uk', title: 'Betfair Exchange', region: 'uk' },
  { key: 'betfair_sb_uk', title: 'Betfair Sportsbook', region: 'uk' },
  { key: 'betvictor', title: 'Bet Victor', region: 'uk' },
  { key: 'betway', title: 'Betway', region: 'uk' },
  { key: 'boylesports', title: 'BoyleSports', region: 'uk' },
  { key: 'casumo', title: 'Casumo', region: 'uk' },
  { key: 'coral', title: 'Coral', region: 'uk' },
  { key: 'grosvenor', title: 'Grosvenor', region: 'uk' },
  { key: 'ladbrokes_uk', title: 'Ladbrokes', region: 'uk' },
  { key: 'leovegas', title: 'LeoVegas', region: 'uk' },
  { key: 'livescorebet', title: 'LiveScore Bet', region: 'uk' },
  { key: 'matchbook', title: 'Matchbook', region: 'uk' },
  { key: 'paddypower', title: 'Paddy Power', region: 'uk' },
  { key: 'skybet', title: 'Sky Bet', region: 'uk' },
  { key: 'smarkets', title: 'Smarkets', region: 'uk' },
  { key: 'unibet_uk', title: 'Unibet', region: 'uk' },
  { key: 'virginbet', title: 'Virgin Bet', region: 'uk' },
  { key: 'williamhill', title: 'William Hill (UK)', region: 'uk' },

  // EU Bookmakers
  { key: 'onexbet', title: '1xBet', region: 'eu' },
  { key: 'betclic_fr', title: 'Betclic (FR)', region: 'eu' },
  { key: 'betfair_ex_eu', title: 'Betfair Exchange', region: 'eu' },
  { key: 'betsson', title: 'Betsson', region: 'eu' },
  { key: 'coolbet', title: 'Coolbet', region: 'eu' },
  { key: 'everygame', title: 'Everygame', region: 'eu' },
  { key: 'gtbets', title: 'GTbets', region: 'eu' },
  { key: 'leovegas_se', title: 'LeoVegas (SE)', region: 'eu' },
  { key: 'marathonbet', title: 'Marathon Bet', region: 'eu' },
  { key: 'nordicbet', title: 'NordicBet', region: 'eu' },
  { key: 'parionssport_fr', title: 'Parions Sport (FR)', region: 'eu' },
  { key: 'pinnacle', title: 'Pinnacle', region: 'eu' },
  { key: 'suprabets', title: 'Suprabets', region: 'eu' },
  { key: 'tipico_de', title: 'Tipico (DE)', region: 'eu' },
  { key: 'unibet_fr', title: 'Unibet (FR)', region: 'eu' },
  { key: 'unibet_it', title: 'Unibet (IT)', region: 'eu' },
  { key: 'unibet_nl', title: 'Unibet (NL)', region: 'eu' },
  { key: 'unibet_se', title: 'Unibet (SE)', region: 'eu' },
  { key: 'winamax_de', title: 'Winamax (DE)', region: 'eu' },
  { key: 'winamax_fr', title: 'Winamax (FR)', region: 'eu' },

  // AU Bookmakers
  { key: 'betfair_ex_au', title: 'Betfair Exchange', region: 'au' },
  { key: 'betr_au', title: 'Betr', region: 'au' },
  { key: 'betright', title: 'Bet Right', region: 'au' },
  { key: 'bet365_au', title: 'Bet365 AU', region: 'au' },
  { key: 'boombet', title: 'BoomBet', region: 'au' },
  { key: 'dabble_au', title: 'Dabble AU', region: 'au' },
  { key: 'ladbrokes_au', title: 'Ladbrokes', region: 'au' },
  { key: 'neds', title: 'Neds', region: 'au' },
  { key: 'playup', title: 'PlayUp', region: 'au' },
  { key: 'pointsbetau', title: 'PointsBet (AU)', region: 'au' },
  { key: 'sportsbet', title: 'SportsBet', region: 'au' },
  { key: 'tab', title: 'TAB', region: 'au' },
  { key: 'tabtouch', title: 'TABtouch', region: 'au' },
  { key: 'unibet', title: 'Unibet', region: 'au' },
];

const US_EXCLUDED_BOOKMAKERS = new Set(['betopenly', 'novig', 'prophetx']);

export const BOOKMAKERS_BY_REGION = {
  us_all: BOOKMAKERS.filter(b => b.region === 'us' || b.region === 'us2' || b.region === 'us_ex'),
  uk: BOOKMAKERS.filter(b => b.region === 'uk'),
  eu: BOOKMAKERS.filter(b => b.region === 'eu'),
  au: BOOKMAKERS.filter(b => b.region === 'au'),
};

export const DEFAULT_US_BOOKMAKERS = BOOKMAKERS
  .filter(
    b =>
      (b.region === 'us' || b.region === 'us2' || b.region === 'us_ex') &&
      !US_EXCLUDED_BOOKMAKERS.has(b.key)
  )
  .map(b => b.key);

export const REGION_LABELS: Record<string, string> = {
  us_all: 'US Sportsbooks',
  uk: 'UK',
  eu: 'EU',
  au: 'AU',
};

// Popular bookmakers for quick selection
export const POPULAR_BOOKMAKERS = [
  'draftkings',
  'fanduel',
  'betmgm',
  'caesars',
  'bovada',
  'bet365',
  'pinnacle',
];
